import { RefreshCw, X } from 'lucide-react';
import { toast } from 'sonner';
import { useStudioImage } from '@/hooks/useStudioImage';

// Replaces the picture of an existing image object while keeping place, size frame, rotation, shape, frame line and effect.
export function replaceImage(editor, o, asset, extra = {}) {
  const ratio = asset.width / asset.height, fitW = Math.min(o.baseW, o.baseH * ratio);
  editor.patchObject(o.id, { assetId: asset.id, cutoutAssetId: null, backgroundRemoved: false, effectAssetId: null, imageView: 'engraving', imageRatio: ratio, crop: { x: 0, y: 0, w: 1, h: 1 }, placeholder: false, upscaled: false, aiGenerated: false, inkArt: false, stockId: null, stockKind: null, stockThumb: null, ...extra, baseW: Number(fitW.toFixed(2)), baseH: Number((fitW / ratio).toFixed(2)), name: o.meta?.field_label || (extra.name || o.name).slice(0, 40) });
}

export const swapTarget = editor => { const o = editor.swap && editor.getObject(editor.swap.id); return o?.type === 'image' && !o.locked ? o : null; };

// Swap with undo; the engraving effect is recomputed for the new picture, the cutout is never redone automatically.
export function swapImage(editor, processing, o, asset, extra = {}) {
  const before = editor.getObject(o.id);
  processing?.cancel(o.id);
  replaceImage(editor, o, asset, extra);
  editor.setSwap(null); editor.select(o.id);
  const fx = o.effect && o.effect !== 'none' ? o.effect : o.placeholder && o.meta?.auto_effect;
  if (fx) setTimeout(() => processing?.applyEffect(o.id, fx, o.effectStrength ?? 50), 0);
  toast.success(o.placeholder ? 'Dein Bild sitzt jetzt im Platzhalter.' : 'Bild ersetzt', { description: 'Position, Größe, Form und Effekt bleiben erhalten.', action: before && { label: 'Rückgängig', onClick: () => { processing?.cancel(o.id); editor.update(prev => prev.map(x => x.id === o.id ? before : x)); editor.select(o.id); } } });
  return o;
}

export const SwapBanner = ({ editor, setPanel }) => {
  const o = swapTarget(editor), { url } = useStudioImage(o?.assetId || null);
  if (!o) return null;
  return <div className="swap-banner" role="status" data-testid="swap-banner"><span className="swap-thumb">{url ? <img src={url} alt="" /> : <RefreshCw size={16} />}</span><span><small>Du ersetzt</small><strong>{o.name || 'Bild'}</strong></span><button type="button" onClick={() => { editor.setSwap(null); setPanel('object'); }} data-testid="swap-cancel"><X size={14} />Abbrechen</button></div>;
};
